export default "__VITE_ASSET__td6EMhnr__"